const Dot = () => (
  <svg width="8px" height="8px" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.932 4A3.932 3.932 0 1 1 .068 4a3.932 3.932 0 0 1 7.864 0Z"
      fill="#fff"
    />
  </svg>
);

export default Dot;
